import * as React from "react";
import TotalItem from "./TotalItem";
import { moneyFormat } from "utils/TextFormattingUtils";

const Totales = ({ documento, classes }) => {
  const totalBruto = (detalles = []) =>
    detalles.reduce(
      (total, detalle) =>
        total +
        (detalle.cantidad * detalle.precioUnitario -
          detalle.valorTotalDescuento),
      0
    );

  const getTotalIva = (detalles = []) =>
    detalles.reduce(
      (total, detalle) =>
        total +
        (detalle.porcentajeIva * (detalle.cantidad * detalle.precioUnitario)) /
          100,
      0
    );

  return (
    <div>
      <div>
        <TotalItem
          title="Total Bruto:"
          value={moneyFormat(totalBruto(documento.detalles))}
          classes={classes}
        />
      </div>
      <div>
        <TotalItem
          title="Total IVA:"
          value={moneyFormat(getTotalIva(documento.detalles))}
          classes={classes}
        />
      </div>
      <div>
        <TotalItem
          title="Total a Pagar:"
          value={moneyFormat(
            totalBruto(documento.detalles) + getTotalIva(documento.detalles)
          )}
          classes={classes}
        />
      </div>
    </div>
  );
};

export default Totales;
